export const MODULE_DASHBOARD = "dashboard"
export const MODULE_ROADWAY = "roadway"
export const MODULE_ROADWORKS = "roadworks"
export const MODULE_ROADSIDE = "roadside"
export const MODULES_ROAD = [MODULE_DASHBOARD, MODULE_ROADWAY, MODULE_ROADWORKS]